import React from 'react';
import styled from 'styled-components';

const DiscussionInteractionCount = ({ inquiries, replies, isSmall = false }) => {

  return (
    <StyledDiscussionInteractionCount className={isSmall ? "is-small" : undefined} >
      <div><strong>{inquiries}</strong> <span>{inquiries === 1 ? "inquiry" : "inquiries"}</span></div>
      <div><strong>{replies}</strong> <span>{replies === 1 ? "reply" : "replies"}</span></div>
    </StyledDiscussionInteractionCount>
  )
}

export default DiscussionInteractionCount;

const StyledDiscussionInteractionCount = styled.div`
  display: flex;
  //grid-template: auto / 1fr 1fr;
  gap: 2px;
  div {
    background-color: #666;
    padding: 0.25em 0.5em;
    border-radius: 0.75em;
    font-size: 0.75em;
    font-weight: 500;
    line-height: 1;
    text-align: center;
    border-radius: 0 0.25em 0.25em 0;
  }
  div:first-of-type {
    background-color: #333;
    color: inherit;
    border-radius: 0.25em 0 0 0.25em;
  }
  @media ( min-width: 48em ) {
    &:not(.is-small) div {
      font-size: 0.875em;
    }
  }
`;